export const ru = {
    'home': 'Домой' ,
    'tours': 'Туры',
    'services' : 'Сервисы',
    'blogs' : 'Блог',
    'about' : 'О нас',
    'contact' : 'Контакты',
    'to_usa' : 'в Соединенные Штаты Америки',
    'to_thailand' : "в Таиланде",
    'to_europe' : "в Европу",
    'to_dubai' : "в Дубаи",
    'to_egypt' : "в Египет",
    'to_malasia' : "в Малайзию",
    'home_icon1' : "Удивительное Путешествие",
    'home_icon1-txt' : "Самые выгодные и интересные туры из Ташкента и только у нас бюджетные туры по всему миру и подарят вам уникальную возможность...",
    'home_icon2' : "Круизные Путешествия",
    'home_icon2-txt' : "Бронируйте круизы напрямую по лучшей цене! Также продажа морских круизов по различным направлениям.",
    'home_icon3' : "Транспортные Услуги",
    'home_icon3-txt' : "Предлагаем транспортные услуги и широкий спектр транспортных услуг для путешествий по городов.",
    'home_icon4' : "Доступное Приобретение Визы",
    'home_icon4-txt' : "Поможем с приобретением визы в другую страну с максимальной эффективностью. Профессиональная визовая поддержка и подберем для Вас самые выгодные предложения по визам и визовой поддержке.",
    'home_cards-title' : "Туры по всему Миру",
    'home_cards-txt' : 'Бюджетные Туры / Индивидуальные Туры /Семейные Туры '
}